// Mesma lista (e ordem do funil) de STATUS_PROPOSTA no api-btk.
export const STATUS = [
  { valor: "enviada", rotulo: "Enviada" },
  { valor: "em_negociacao", rotulo: "Em negociação" },
  { valor: "aprovada", rotulo: "Aprovada" },
  { valor: "recusada", rotulo: "Recusada" },
  { valor: "cancelada", rotulo: "Cancelada" },
];

export const OBSERVACAO_MAXIMA = 500;

export const rotuloStatus = (valor) =>
  STATUS.find((status) => status.valor === valor)?.rotulo ?? valor;

// Mesma lista de CANAIS_ENVIO no api-btk.
export const CANAIS_ENVIO = [
  { valor: "whatsapp", rotulo: "WhatsApp" },
  { valor: "email", rotulo: "E-mail" },
];

// Propostas capturadas antes do campo existir nao tem canal.
export const rotuloCanal = (valor) =>
  CANAIS_ENVIO.find((canal) => canal.valor === valor)?.rotulo ?? "—";

const moeda = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

// "1234.56" -> "R$ 1.234,56"
export function formatarMoeda(valor) {
  if (valor === null || valor === undefined || valor === "") return "—";
  const numero = Number(valor);
  return Number.isFinite(numero) ? moeda.format(numero) : "—";
}

// "2026-10-14" -> "14/10/2026" (sem passar por Date para nao mudar de dia pelo fuso)
export function formatarData(iso) {
  const partes = iso?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : "—";
}

export function formatarDataHora(iso) {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "—";
  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const MINUTO = 60 * 1000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

// "agora", "há 5 min", "há 3 h", "ontem", "há 4 dias"; depois de uma semana, a data.
export function tempoRelativo(iso, agora = Date.now()) {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "—";

  const diferenca = Math.max(0, agora - data.getTime());
  if (diferenca < MINUTO) return "agora";
  if (diferenca < HORA) return `há ${Math.floor(diferenca / MINUTO)} min`;
  if (diferenca < DIA) return `há ${Math.floor(diferenca / HORA)} h`;
  if (diferenca < 2 * DIA) return "ontem";
  if (diferenca < 7 * DIA) return `há ${Math.floor(diferenca / DIA)} dias`;
  return formatarDataHora(iso).split(",")[0];
}

// Digitos -> CNPJ "12.345.678/0001-90" ou CPF "123.456.789-01"
export function formatarDocumento(documento) {
  const digitos = String(documento ?? "").replace(/\D/g, "");
  if (digitos.length === 14) {
    return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }
  if (digitos.length === 11) {
    return digitos.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }
  return digitos || "—";
}

export function formatarCep(cep) {
  const digitos = String(cep ?? "").replace(/\D/g, "");
  return digitos.length === 8 ? `${digitos.slice(0, 5)}-${digitos.slice(5)}` : "—";
}
